import { useSelector, useDispatch } from "react-redux";
import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";
import { useEffect } from "react";
import uniqueBnDevSlice, { graphUniqueBnDev, SelectUniqueBrowsers, SelectgraphUniqueBnDevStatus, SelectWeeks, SelectUniqueEngaged, setUniqueEngaged } from "./uniqueBnDevSlice";
import { NumberOfUniqueVisitorsGraph } from "../../../../components/Graphs/graphs";
import { SelectPercentVisitors } from "../SessionDistribution/sessionDistributionSlice";
import { SingleGraphLoading } from "../../../../components/Skeletons";



const UniqueBnDev = ({ display }) => {
  const dispatch = useDispatch();
  const sessionUser = useSelector(selectLogInUsername)
  const user = sessionUser?.split('@')[0];
  
  // const UniqueBnDevData = useSelector(state => state.uniqueBnDev)
  const loading = useSelector(SelectgraphUniqueBnDevStatus);
  const uniqueBrowsers = useSelector(SelectUniqueBrowsers);
  const uniqueEngaged = useSelector(SelectUniqueEngaged);
  const weeks = useSelector(SelectWeeks);
  const percentVisitors = useSelector(SelectPercentVisitors)
  console.log('percentVisitors in UniqueBnDev:', percentVisitors);
  console.log('uniqueBrowsers in UniqueBnDev:', uniqueBrowsers);
  
  useEffect(() => {
    if (!user) return null
    if(weeks.length===0) dispatch(graphUniqueBnDev(user))
  }, [user, weeks])


  useEffect(() => {
    if (percentVisitors.length === 0) return;
    let tempArr = [...percentVisitors];
      let engagedArray = tempArr.reverse().map((value, index) => {
        return Math.round(uniqueBrowsers[index] * (value[0] / 100));
      });
      dispatch(setUniqueEngaged(engagedArray));
  }, [percentVisitors, uniqueBrowsers]);


  if (loading === 'loading') return <SingleGraphLoading />
  
  return (
    <> 
      <NumberOfUniqueVisitorsGraph
        uniqueBrowsers={uniqueBrowsers}
        engaged={uniqueEngaged}
        weeks={weeks}
        display={display}
        />
        
    </>
  )
}

export default UniqueBnDev;




